import _uniqueId from "lodash/uniqueId";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import classNames from 'clsx';
import Box from "../Box";
import Card from "../Card";
import ContextualLayer from "../Layer/ContextualLayer";
import { InputBaseContext } from "../Input/InputBase";
import { InputGroupContext } from "../Input/InputGroup";
import Icon from "../Icon";
import { arrowUpDown } from '@sail/icons/react/Icon';
import { PressableButton, PressableContext, PressableCore } from "../Pressable";
import { moveUp, moveDown } from "../ScrollableMenu";
import SearchableList from "./SearchableList";
import SearchableListInput from "./SearchableListInput";
import SearchableSelectResult from "./SearchableSelectResult";
import { Text } from "../Text";
import TruncatedText from "../TruncatedText";
import FocusHandler from "../handler/FocusHandler";
import HoverHandler from "../handler/HoverHandler";
import KeyCodes from "../lib/KeyCodes";
const BUTTON_KEYDOWN_DELAY = 800;
export const SearchableSelectDropdown = (props
// @ts-expect-error - TS2322 - Type 'ReactNode' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
) => props.children;
const resetFlipped = () => ({
  canFlip: true,
  contextMeetingPoint: 'bottomleft',
  layerMeetingPoint: 'topleft'
});
class SearchableSelect extends React.Component {
  constructor(_props) {
    super(_props);
    this.button = void 0;
    this.buttonKeyDownTimeout = void 0;
    this.container = void 0;
    // @ts-expect-error - TS2564 - Property 'searchableList' has no initializer and is not definitely assigned in the constructor.
    this.searchableList = void 0;
    this.autoCompleteID = void 0;
    this.buttonRef = node => {
      this.button = node;
    };
    this.containerRef = node => {
      this.container = node;
    };
    this.searchableListRef = searchableList => {
      this.searchableList = searchableList;
    };
    this.handleToggle = () => {
      if (this.state.open) {
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        this.setState({
          open: false,
          flipped: resetFlipped()
        });
      } else {
        this.open({
          highlightedIndex: 0
        });
      }
    };
    this.handleBlur = () => {
      if (this.props.onBlur) {
        this.props.onBlur();
      }
    };
    this.handleClickOutside = e => {
      // Clicking on the button (or anything within it) should not be regarded
      // as a "click outside" the layer, and should be effectively ignored here.
      const {
        target
      } = e;
      if (target instanceof Node && this.container && this.container.contains(target) && this.state.open) {
        return 'not-handled';
      }

      // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
      this.setState({
        open: false,
        flipped: resetFlipped()
      });
      return 'handled';
    };
    this.handleButtonKeyDown = e => {
      // Always clear the keydown timeout.
      this.clearButtonKeyDown();
      const {
        results
      } = this.state;
      const {
        getSearchableText,
        value
      } = this.props;

      // If no behavior specified, no results, or possible commands: discard.
      if (!results.length || e.getModifierState('Alt') || e.getModifierState('Control') || e.getModifierState('Meta')) {
        return;
      }
      const {
        key
      } = e;

      // For native `select` elements, the spacebar key opens the element. Do the same here.
      if (key === ' ') {
        e.preventDefault();
        this.open();
        return;
      }
      const cursor = value ? results.indexOf(value) : -1;

      /**
       * Handle control keys. Any previously-typed characters should be
       * discarded, and `onChange` should fire if arrow keys are used.
       */
      if (key.length !== 1) {
        const arrowKey = key === 'ArrowDown' || key === 'ArrowUp';
        if (arrowKey) {
          e.preventDefault();
          this.setState({
            open: true
          });
        }
        this.setState({
          buttonKeys: ''
        }, () => {
          // If up/down arrow keys are used, iterate to the next value.
          if (arrowKey) {
            const nextTarget = key === 'ArrowDown' ? moveDown(results.length, cursor) : moveUp(results.length, cursor);
            this.props.onChange(results[nextTarget]);
          }
        });
        return;
      }
      if (!getSearchableText) {
        return;
      }
      e.preventDefault();
      const {
        buttonKeys
      } = this.state;
      const typedChar = key.toLowerCase();

      /**
       * If the same key was pressed again, don't add it on. Instead, use the
       * value to search again so that pressing the key iterates through first-
       * character matches.
       */
      const typedString = buttonKeys === typedChar ? buttonKeys : buttonKeys + typedChar;

      /**
       * 1. Iterate through the results, starting just after the currently
       *    selected item, if any.
       * 2. Find the first match in `results` that is *not* the current value.
       */
      const resultOrder = results.slice(cursor).concat(results.slice(0, cursor));
      const match = resultOrder.find(result => {
        const searchableText = getSearchableText(result).toLowerCase();
        return searchableText.startsWith(typedString) && result !== value;
      });
      if (match) {
        this.props.onChange(match);
      }

      // Track the full typed string, if it has changed.
      if (typedString !== buttonKeys) {
        this.setState({
          buttonKeys: typedString
        });
      }

      // After a delay, clear the typed string.
      // @ts-expect-error - TS2322 - Type 'Timeout' is not assignable to type 'number'.
      this.buttonKeyDownTimeout = setTimeout(() => {
        this.setState({
          buttonKeys: ''
        });
      }, BUTTON_KEYDOWN_DELAY);
    };
    this.handleKeyDown = e => {
      const {
        keyCode
      } = e;
      if (keyCode === KeyCodes.ESCAPE) {
        e.preventDefault();
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        this.setState({
          open: false,
          flipped: resetFlipped()
        });
      } else if (keyCode === KeyCodes.TAB) {
        // when clicking tab, close the select and tab to the next tabbable item
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        this.setState({
          open: false,
          flipped: resetFlipped()
        });
      }
    };
    this.handleHighlight = highlightedIndex => {
      this.setState({
        highlightedIndex
      });
    };
    this.handleChangeQuery = query => {
      this.props.onChangeQuery(query);
    };
    this.handleSelect = entry => {
      // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
      this.setState({
        open: false,
        flipped: resetFlipped()
      }, () => {
        this.props.onChange(entry);
      });
    };
    this.handleAutoComplete = evt => {
      // This specially *does not* remove the input from the page because a user could
      // use the "clear the form" feature of the browser's autocomplete and try to
      // autocomplete the form again.
      const {
        onAutoComplete
      } = this.props;
      const autoCompleteValue = evt.target.value;
      if (onAutoComplete) {
        onAutoComplete(autoCompleteValue);
      }
    };
    this.adjustMeetingPoints = (context, layer) => {
      const {
        canFlip,
        contextMeetingPoint,
        layerMeetingPoint
      } = this.state.flipped;
      if (!canFlip) {
        return {
          context: contextMeetingPoint,
          layer: layerMeetingPoint
        };
      }
      const flipped = {
        canFlip: false,
        contextMeetingPoint: context,
        layerMeetingPoint: layer
      };
      this.setState({
        flipped
      });
      return {
        context,
        layer
      };
    };
    this.adjustOffsets = (context, layer, offsetX, offsetY) => {
      // If it is flipped invert the offsetY
      if (context === 'topleft' && layer === 'bottomleft') {
        // This uses `offsetY * -1` to invert in case someone just changes the offsetY in renderLayer
        return {
          x: offsetX,
          y: offsetY * -1
        };
      }
      return {
        x: offsetX,
        y: offsetY
      };
    };
    this.renderItem = props => {
      const {
        queryString,
        renderItem
      } = this.props;
      return /*#__PURE__*/React.createElement(SearchableSelectResult, {
        entry: props.entry,
        highlighted: props.highlighted,
        queryString: queryString,
        renderResult: renderItem
      });
    };
    this.renderAutoCompleteHiddenInput = () => {
      // If this rendered, we know we have an `autoComplete` prop
      const {
        autoComplete = ''
      } = this.props;
      // This uses `aria-hidden` and `tabIndex={-1}` because the browser is smart enough
      // to know that `hidden` or `type="hidden"` inputs should not be autofilled.

      // The class zeros everything out about this input, which the browser doesn't consider
      // when deciding on autofill behavior. It seems that the some browsers might consider
      // `display: none` and `visibility: hidden`, so we don't want to use those.

      // This is also an uncontrolled component (`defaultValue`) so nothing in React can
      // change the value of this component and we know it came from outside React.
      return /*#__PURE__*/React.createElement("input", {
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | undefined'.
        id: this.autoCompleteID,
        type: "text",
        "aria-hidden": true,
        tabIndex: -1,
        defaultValue: "",
        className: "SearchableSelect-autocomplete-hidden-input",
        autoComplete: autoComplete,
        onChange: this.handleAutoComplete
      });
    };
    this.state = {
      buttonKeys: '',
      highlightedIndex: 0,
      dropdownWidth: _props.dropdownWidth || _props.width,
      open: false,
      results: _props.results,
      // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
      flipped: resetFlipped()
    };

    // A unique `id` needs to be generated that includes the `autoComplete` value because
    // 1password seems to only look at `id` and matches against that
    const {
      autoComplete: _autoComplete = ''
    } = this.props;
    if (_autoComplete) {
      this.autoCompleteID = _uniqueId(`${_autoComplete}-AutoComplete-HiddenInput`);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.open && !prevState.open && this.searchableList) {
      this.searchableList.focus();
    } else if (!this.state.open && prevState.open && this.button) {
      this.button.focus();
    }
  }
  componentWillUnmount() {
    this.clearButtonKeyDown();
  }
  clearButtonKeyDown() {
    this.buttonKeyDownTimeout && clearTimeout(this.buttonKeyDownTimeout);
    this.buttonKeyDownTimeout = null;
  }
  getHighlightedIndex(entry) {
    return entry ? this.state.results.indexOf(entry) : -1;
  }
  focus() {
    if (this.searchableList) {
      this.searchableList.focus();
    }
  }
  open(state, next) {
    if (this.container) {
      const dropdownWidth = this.props.getDropdownWidth && this.props.getDropdownWidth() || this.props.dropdownWidth || this.container.getBoundingClientRect().width || this.props.width;
      // @ts-expect-error - TS2345 - Argument of type '{ buttonKeys?: string | undefined; highlightedIndex?: number | undefined; dropdownWidth: PressableCoreWidth; open: boolean; results?: readonly T[] | undefined; flipped?: FlippedState | undefined; }' is not assignable to parameter of type 'State<T> | ((prevState: Readonly<State<T>>, props: Readonly<SearchableSelectProps<T>>) => State<T> | Pick<...> | null) | Pick<...> | null'.
      this.setState(_objectSpread({
        open: true,
        dropdownWidth
      }, state), next);
    }
  }
  renderLayer() {
    const container = this.container;
    if (!container || !this.state.open) {
      return null;
    }
    const {
      inputPlaceholder,
      queryString,
      renderEmpty,
      renderError,
      renderInput,
      status,
      autoflip
    } = this.props;
    const {
      highlightedIndex,
      dropdownWidth,
      results,
      flipped: {
        contextMeetingPoint,
        layerMeetingPoint
      }
    } = this.state;
    const autoflipBehavior = autoflip ? 'vertical' : false;
    const adjustMeetingPoints = autoflip ? this.adjustMeetingPoints : undefined;
    const adjustOffsets = autoflip ? this.adjustOffsets : undefined;
    return /*#__PURE__*/React.createElement(SearchableSelectDropdown, null, /*#__PURE__*/React.createElement(ContextualLayer, {
      autoflip: autoflipBehavior,
      adjustMeetingPoints: adjustMeetingPoints,
      adjustOffsets: adjustOffsets,
      context: {
        element: container
      },
      contextMeetingPoint: contextMeetingPoint,
      layerMeetingPoint: layerMeetingPoint,
      onClickOutside: this.handleClickOutside,
      offsetY: 4
    }, /*#__PURE__*/React.createElement(PressableCore, {
      width: dropdownWidth
    }, /*#__PURE__*/React.createElement(Card, {
      className: "SearchableSelect-layerContents",
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(SearchableList, {
      highlightedIndex: highlightedIndex,
      inputPlaceholder: inputPlaceholder,
      onChangeQuery: this.handleChangeQuery,
      onHighlight: this.handleHighlight,
      onKeyDown: this.handleKeyDown,
      onSelect: this.handleSelect,
      queryString: queryString,
      ref: this.searchableListRef,
      renderInput: renderInput,
      results: results,
      renderEmpty: renderEmpty,
      renderError: renderError,
      renderItem: this.renderItem,
      status: status
    })))));
  }
  render() {
    return /*#__PURE__*/React.createElement(InputBaseContext.Consumer, null, inputBaseContext => {
      return /*#__PURE__*/React.createElement(InputGroupContext.Consumer, null, inputGroupContext => {
        const {
          getButtonLabel,
          getFormValue,
          chooseLabel,
          ghost,
          invalid,
          value,
          name,
          disabled,
          radius,
          size,
          width,
          autoComplete,
          onAutoComplete
        } = this.props;
        const {
          open
        } = this.state;
        const shouldRenderAutoComplete = autoComplete && onAutoComplete;
        const formValue = value && getFormValue ? getFormValue(value) : '';
        const buttonLabel = value ? getButtonLabel(value) : chooseLabel;
        const classes = classNames('SearchableSelect-container', {
          'SearchableSelect-container--size--jumbo': size === 'jumbo',
          'SearchableSelect-container--size--large': size === 'large',
          'SearchableSelect-container--size--medium': size === 'medium',
          'SearchableSelect-container--size--small': size === 'small'
        });
        const disabledValue = inputBaseContext && inputBaseContext.disabled || inputGroupContext && inputGroupContext.disabled || disabled;
        const invalidValue = inputBaseContext && inputBaseContext.invalid || inputGroupContext && inputGroupContext.invalid || invalid;
        const ghostValue = inputBaseContext && inputBaseContext.ghost || ghost;
        const radiusValue = inputBaseContext && inputBaseContext.radius || inputGroupContext && inputGroupContext.radius || radius;
        const sizeValue = inputBaseContext && inputBaseContext.size || inputGroupContext && inputGroupContext.size || size;
        const pressableButtonClasses = classNames('SearchableSelect-button', inputBaseContext.inputBaseClassName, inputGroupContext.inputGroupClassName);
        const inputUsesFormName = formValue || open;
        return /*#__PURE__*/React.createElement(PressableCore, {
          width: width
        }, /*#__PURE__*/React.createElement(Box, {
          className: classes,
          boxRef: this.containerRef
        }, shouldRenderAutoComplete ? this.renderAutoCompleteHiddenInput() : null, /*#__PURE__*/React.createElement("input", {
          "aria-invalid": invalidValue && 'true',
          type: "hidden",
          name: inputUsesFormName ? name : undefined,
          value: formValue
        }), /*#__PURE__*/React.createElement(FocusHandler, null, (focusProps, inputMethod) => {
          const isFocused = inputMethod !== null;
          return /*#__PURE__*/React.createElement(HoverHandler, null, (hoverProps, isHovering) => /*#__PURE__*/React.createElement(PressableButton, _extends({}, focusProps, hoverProps, {
            className: pressableButtonClasses,
            disabled: disabledValue,
            focused: isFocused,
            ghost: ghostValue,
            hovered: isHovering,
            invalid: invalidValue,
            radius: radiusValue,
            size: sizeValue,
            width: "maximized"
          }), /*#__PURE__*/React.createElement(PressableContext.Consumer, null, ({
            pressableContextClasses,
            color,
            fontLineHeight,
            fontSize,
            fontWeight,
            style
          }) => /*#__PURE__*/React.createElement("button", {
            "aria-expanded": open,
            "aria-haspopup": "true",
            "aria-label": chooseLabel,
            className: classNames('SearchableSelect-element', pressableContextClasses),
            disabled: disabled,
            onClick: this.handleToggle,
            onKeyDown: this.handleButtonKeyDown,
            onBlur: this.handleBlur,
            ref: this.buttonRef,
            type: "button",
            style: style,
            name: !inputUsesFormName ? name : undefined,
            role: "combobox"
          }, /*#__PURE__*/React.createElement(Box, {
            padding: {
              right: size === 'jumbo' ? 20 : 16
            },
            style: {
              width: '100%'
            }
          }, /*#__PURE__*/React.createElement(TruncatedText, null, /*#__PURE__*/React.createElement(Text, {
            color: color,
            lineHeight: fontLineHeight,
            size: size === 'large' ? 14 : fontSize,
            weight: fontWeight,
            wrap: false
          }, buttonLabel))), /*#__PURE__*/React.createElement(Icon, {
            className: "SearchableSelect-arrows",
            color: color,
            icon: arrowUpDown,
            size: size === 'jumbo' ? 16 : 12
          })))));
        }), this.renderLayer()));
      });
    });
  }
}
// @ts-expect-error - TS2302 - Static members cannot reference class type parameters.
SearchableSelect.defaultProps = {
  chooseLabel: 'Choose…',
  ghost: false,
  invalid: false,
  width: 240,
  disabled: false,
  radius: 'all',
  renderEmpty: () => /*#__PURE__*/React.createElement("div", null),
  renderError: () => /*#__PURE__*/React.createElement("div", null),
  renderInput: props => /*#__PURE__*/React.createElement(SearchableListInput, props),
  size: 'medium',
  autoflip: false
};
SearchableSelect.getDerivedStateFromProps = (props, state) => {
  if (props.results !== state.results) {
    return {
      results: props.results
    };
  }
  const {
    highlightedIndex: currentHighlightIndex
  } = state;
  if (currentHighlightIndex <= 0) {
    return {
      results: props.results
    };
  }
  const currentHighlight = state.results[currentHighlightIndex];
  const nextIndexForHighlight = props.results.indexOf(currentHighlight);
  if (nextIndexForHighlight !== -1) {
    return {
      results: props.results,
      highlightedIndex: nextIndexForHighlight
    };
  }
  return {
    results: props.results,
    highlightedIndex: 0
  };
};
export default SearchableSelect;